import { render, staticRenderFns } from "./FixtureDetails.vue?vue&type=template&id=8e6f1ca4&scoped=true"
import script from "./FixtureDetails.vue?vue&type=script&lang=js"
export * from "./FixtureDetails.vue?vue&type=script&lang=js"
import style0 from "./FixtureDetails.vue?vue&type=style&index=0&id=8e6f1ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6f1ca4",
  null
  
)

export default component.exports